import styled from 'styled-components';
import sizes from 'styles/sizes';
import colors from 'styles/colors';
import fonts from 'styles/fonts';
import { BrandCode } from 'types';

export const Grid = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0px;
	margin-top: 10px;

	@media (min-width: ${sizes.media.tabletMinWidth}px) {
		flex-direction: row;
		gap: 140px;
		margin-top: 20px;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	background: white;
	@media (min-width: ${sizes.media.tabletMinWidth}px) {
		align-items: flex-start;
		justify-content: space-between;
		flex-direction: column;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;

	background: white;
	margin-top: 20px;
	margin-bottom: 20px;
	@media (min-width: ${sizes.media.tabletMinWidth}px) {
		margin-top: 0px;
		margin-bottom: 20px;
	}
`;

export const Label = styled.label`
	font-family: ${({ theme }) => theme.typography.fontFamily};
	font-size: 14px;
	font-weight: 400;
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
      color: ${theme.palette.secondary.main};
    `,
			[BrandCode.RoyalCaribbean]: `
      color: ${colors.functional.softGrey};
    `,
		})[theme.brandCode]}
`;

export const FilterTitle = styled.h1`
	font-size: 18px;
	margin-bottom: 5px;
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
    color: ${theme.palette.text.secondary};
    font-family: ${theme.typography.fontFamily};
  `,
			[BrandCode.RoyalCaribbean]: `
    color: ${theme.palette.secondary.main};
    font-family: ${theme.typography.fontFamily};
    font-weight: 600;
  `,
		})[theme.brandCode]}
`;

export const SectionLabel = styled.label`
  color: ${colors.functional.softGrey};
  margin-top: 20px;

  ${({ theme }) => ({
    [BrandCode.Celebrity]: `
      font-family: ${theme.typography.fontFamilySemiBold};
      font-size: 18px;

      @media (min-width: ${sizes.media.smallMaxWidth}px) {
        font-family: ${theme.typography.fontFamily};
      }
    `,
    [BrandCode.RoyalCaribbean]: `
      font-family: ${theme.typography.fontFamily};
      font-size: 16px;
      font-style: italic;

      @media (min-width: ${sizes.media.tabletMinWidth}px) {
        font-size: 14px;
      }
    `,
  }[theme.brandCode])}
`;

export const Button = styled.button`
	border: solid 1px ${colors.secondary.deepCoveVeryLight};
	opacity: ${(props) => (props.disabled ? '0.35;' : '1')};
	display: flex;
	padding: 10px;
	align-items: center;
	gap: 10px;
	border-radius: 50%;
	cursor: pointer;
	@media (min-width: ${sizes.media.tabletMinWidth}px) {
		align-items: flex-start;
		justify-content: center;
	}
	&:disabled {
		cursor: unset;
	}
`;

export const ButtonWrap = styled.div`
	display: flex;
	max-width: 122px;
	transition: opacity 0.2s cubic-bezier(0, 0, 0, 0);
`;

export const Input = styled.input`
	font-family: ${fonts.primary.regular};
	color: ${colors.functional.black};
	border: none;
	font-size: 16px;
	height: 34px;
	width: 34px;
	outline: none;
	margin-inline: 10px;
	text-align: center;
	&::placeholder {
		color: ${colors.secondary.deepCoveVeryLight};
	}
	&:focus {
		caret-color: transparent;
	}
`;
